import { GenericModelV2, ModelCategory, ProcessingPipelineParams } from './definitions';
import { DEFAULT_SIGNATURE_PROCESSING_PARAMS } from './signature';

export const getModelPreprocessingParams = (model: GenericModelV2) => {
  let processingParams: ProcessingPipelineParams;
  if (model.data.type === ModelCategory.ComparisonIntensities) {
    processingParams = { ...DEFAULT_SIGNATURE_PROCESSING_PARAMS, normalisation: undefined };
  } else if (model.data.type === ModelCategory.ChemicalPrediction && model.data.customNormalisation !== undefined) {
    processingParams = { ...DEFAULT_SIGNATURE_PROCESSING_PARAMS, normalisation: { type: 'customMinMax', rules: model.data.customNormalisation } };
  } else if (model.data.type === ModelCategory.RulesBased && model.data.customProcessingParams !== undefined) {
    processingParams = model.data.customProcessingParams;
  } else {
    processingParams = DEFAULT_SIGNATURE_PROCESSING_PARAMS;
  }
  return processingParams;
};
